import { render, staticRenderFns } from "./register-objectives.vue?vue&type=template&id=c1d9d518&"
import script from "./register-objectives.vue?vue&type=script&lang=js&"
export * from "./register-objectives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports